module.exports = __webpack_public_path__ + "img/kr.8a067f19.svg";